var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachedFile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.36 6H19l-4.995-5v4.643c-.035.178.107.321.284.357h.07z",
    fill: "#00BA8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.966 5.944c0 1.04.815 1.857 1.852 1.857H20v15.97C20 24.998 19 26 17.777 26H2.223A2.232 2.232 0 0 1 0 23.772V2.229C0 1.003 1 0 2.222 0h9.744v5.944zm-.171 9.051 2.063-1.563a.367.367 0 0 0 .125-.403.357.357 0 0 0-.124-.18.334.334 0 0 0-.202-.069h-.002l-2.545.006-.783-2.537A.346.346 0 0 0 10 10h-.014a.04.04 0 0 0-.008.001H9.97a.347.347 0 0 0-.298.248l-.782 2.537-2.535-.005h-.01c-.15 0-.282.1-.328.248a.368.368 0 0 0 .125.403l2.063 1.563-.792 2.533-.003.014a.363.363 0 0 0 .128.39.332.332 0 0 0 .405 0l2.056-1.572 2.058 1.571a.061.061 0 0 0 .012.008l.002.001a.333.333 0 0 0 .391-.009.365.365 0 0 0 .125-.403l-.792-2.533z",
    fill: "#00BA8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachedFile);
export default __webpack_public_path__ + "static/media/attached-file.8b9ab654.svg";
export { ForwardRef as ReactComponent };